module.exports = __webpack_public_path__ + "components/flag/static/square/de-d6abf8578f4af05638042cdd31fed3cc.svg";